<template>
  <div class="weather-options-setting-dialog">
    <div class="content-group-default">
      <el-collapse v-model="activeNames" style="width: 100%">
        <controlWidthAndSizeAndZindex :options="options" :ids="ids"/>
        <el-collapse-item
            @mousedown.native="collapseMouseDown(collapseActiveNames, $event, '1')"
            title="日期配置"
            name="1"
        >
          <div
              class="setting-item clearFloat"
              v-if="collapseActiveNames.length !== 0 && collapseActiveNames.find(it => it === '2')"
          >
            <div class="content">
              <div class="verticallyCenter">
                <span class="font14 mr10 mb10" style="width: 57px">日期类型</span>
                <el-select popper-class="date-style-select" class="mb10" v-model="dateType" placeholder="请选择">
                  <el-option v-for="item in dateTypesOption" :key="item.value" :label="item.label" :value="item.value">
                  </el-option>
                </el-select>
              </div>
              <div class="verticallyCenter">
                <span class="font14 mr10 mb10" style="width: 57px">日期格式</span>
                <el-select popper-class="date-style-select" class="mb10" v-model="dateFormat" placeholder="请选择">
                  <el-option v-for="item in formatOptions" :key="item.value" :label="item.label"
                             :value="item.value">
                  </el-option>
                </el-select>
              </div>
              <div class="mt12" v-if="options.dataPickerType === 1 || options.dataPickerType === 3">
                <cx-check-box :value.sync="defaultToday">默认选中当前日期</cx-check-box>
                <div class="padding16" v-if="defaultToday && options.dataPickerType === 3">
                  <div class="verticallyCenter borderRadius4">
                    <span class="font14 mr6 half-label">前</span>
                    <el-input
                        class="percent65_"
                        v-model="todayRange"
                        placeholder="请输入"
                        :controls="false"
                        :min="1"
                        :step="1"
                        type="number"
                        v-inputHandle="{ this1, type: 'todayRange' }"
                    >
                      <template slot="suffix">
                        <span class="suffix_text" v-if="dateType === 'monthrange'">月</span>
                        <span class="suffix_text" v-else>天</span>
                      </template>
                    </el-input>
                  </div>
                  <div class="verticallyCenter borderRadius4 mt16" v-if="dateType === 'datetimerange'">
                    <span class="font14 mr6 half-label">前</span>
                    <el-input
                        class="percent65_"
                        v-model="todayRangeTime"
                        placeholder="请输入"
                        :controls="false"
                        :min="1"
                        :step="1"
                        type="number"
                        v-inputHandle="{ this1, type: 'todayRangeTime' }"
                    >
                      <template slot="suffix">
                        <span class="suffix_text">小时</span>
                      </template>
                    </el-input>
                  </div>
                </div>
              </div>
              <!--              快捷功能很复杂，每个不同类型的日期显示的快捷方式不一样，需要手动定义-->
              <!--              <div>-->
              <!--                <div class="mb16">-->
              <!--                  <el-checkbox v-model="showShortcuts">显示快捷选项</el-checkbox>-->
              <!--                </div>-->
              <!--                <div  class="verticallyCenter" v-show="showShortcuts">-->
              <!--                  <span class="font14 mr10 mb10" style="width: 57px">快捷选项</span>-->
              <!--                  <el-select popper-class="date-style-select" class="mb10" v-model="shortcuts" placeholder="请选择">-->
              <!--                    <el-option v-for="item in shortcutsOptions" :key="item.value" :label="item.label" :value="item.value">-->
              <!--                    </el-option>-->
              <!--                  </el-select>-->
              <!--                </div>-->
              <!--              </div>-->
              <div class="mt12" v-if="dateType === 'date'">
                <div class="verticallyCenter">
                  <cx-check-box :value.sync="dateSelectRange">日期可选范围</cx-check-box>
                  <el-tooltip
                    :open-delay="1000"
                    class="item"
                    effect="dark"
                    content="开启后，只能选择可选范围内的日期"
                    placement="top"
                  >
                    <span class="tips-btn icon-portal-info2"></span>
                  </el-tooltip>
                </div>
                <div class="mapping_content mt6" v-if="dateSelectRange">
                  <div>
                    <el-select popper-class="date-style-select" v-model="selectRangeText" placeholder="请选择" style="width: 68px;">
                      <el-option value="before" label="早于"></el-option>
                      <el-option value="after" label="晚于"></el-option>
                      <el-option value="equal" label="等于"></el-option>
                    </el-select>
                    <el-select popper-class="date-style-select" class="" v-model="selectRangeDate" placeholder="请选择" style="width: 84px;margin-left: 6px;">
                      <el-option value="date" label="具体日期"></el-option>
                      <el-option value="today" label="今天"></el-option>
                      <el-option value="yesterday" label="昨天"></el-option>
                      <el-option value="tomorrow" label="明天"></el-option>
                      <el-option value="week" label="本周"></el-option>
                      <el-option value="month" label="本月"></el-option>
                    </el-select>
                  </div>
                  <div class="mt6" v-if="selectRangeDate === 'date'">
                    <el-date-picker
                      class="date-picker-box"
                      v-model="selectDate"
                      type="date"
                      placeholder="yyyy-mm-dd"
                      popper-class="select-range-date">
                    </el-date-picker>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </el-collapse-item>
        <el-collapse-item
            @mousedown.native="collapseMouseDown(collapseActiveNames, $event, '2')"
            title="外观"
            name="2"
        >
          <div
              class="setting-item clearFloat mb16"
              v-if="collapseActiveNames.length !== 0 && collapseActiveNames.find(it => it === '2')"
          >
            <div class="content">
              <div class="mb16">
                <span class="mb8 inlineMiddle">文字样式</span>
                <text-setting-update
                    :fontColor.sync="fontColor"
                    :fontFamily.sync="fontFamily"
                    :fontSize.sync="fontSize"
                    :fontWeight.sync="fontWeight"
                />
              </div>
              <div class="content-item mb24 clearFloat">
                <div class="checkbox_colorPicker_container mb16">
                  <!--                  <el-checkbox v-model="borderChecked" @change="checkboxHandle(2, '')">边框</el-checkbox>-->
                  <span class="fs14">边框</span>
                </div>
                <div class="select-input-container verticallyTop">
                  <cx-border
                      :borderWidth.sync="borderWidth"
                      :borderStyle.sync="borderStyle"
                      :borderColor.sync="borderColor"
                      :borderIsThemeColor.sync="borderIsThemeColor"
                  />
                </div>
              </div>
              <div class="content-item mb16">
                <border-radius
                    :borderTypeFlag.sync="borderTypeFlag"
                    :borderRadius.sync="borderRadius"
                    :borderTopLeftRadius.sync="borderTopLeftRadius"
                    :borderTopRightRadius.sync="borderTopRightRadius"
                    :borderBottomRightRadius.sync="borderBottomRightRadius"
                    :borderBottomLeftRadius.sync="borderBottomLeftRadius"
                />
              </div>
              <cx-background :background.sync="background" imgType="10" class="mt16" :hasAddBtn="false"/>
              <div class="content-item mt16">
                <div class="checkbox_colorPicker_container">
                  <span>阴影</span>
                  <span
                      class="icon-portal-plus theme-color right-icon"
                      @click="addBoxshadow"
                  ></span>
                </div>
                <box-shadow
                    :boxShadowH.sync="boxShadowH"
                    :boxShadowV.sync="boxShadowV"
                    :boxShadowBlur.sync="boxShadowBlur"
                    :boxShadowSpread.sync="boxShadowSpread"
                    :boxShadowColor.sync="boxShadowColor"
                ></box-shadow>
              </div>
            </div>
          </div>
        </el-collapse-item>
        <el-collapse-item
            @mousedown.native="collapseMouseDown(collapseActiveNames, $event, '3')"
            title="标题样式"
            name="3"
        >
          <div
              class="setting-item"
              v-if="collapseActiveNames.length !== 0 && collapseActiveNames.find(it => it === '3')"
          >
            <div class="content">
              <div class="content-item mb16">
                <!-- 字体和颜色/字重和字号 -->
                <text-setting-complex-update
                    class="mb16"
                    :fontFamily.sync="titleFontFamily"
                    :fontSize.sync="titleFontSize"
                    :fontWeight.sync="titleFontWeight"
                    :fontStyle.sync="titleFontStyle"
                    :textDecoration.sync="titleTextDecoration"
                    :lineHeight.sync="titleLineHeight"
                    :lineHeightType.sync="titleLineHeightType"
                    :letterSpacing.sync="titleLetterSpacing"
                    :activeArrangement.sync="titleActiveArrangement"
                    :writingMode.sync="titleWritingMode"
                    :textAlign.sync="titleTextAlign"
                    :activeArrangementOrder.sync="titleActiveArrangementOrder"
                    :isThemeColor.sync="titleTextIsThemeColor"
                    :colorArr.sync="titleColor"
                    :options="options"
                />
                <!-- <div class="verticallyCenter mb16">
                  <span class="fs14 mr16 keep-all">文字颜色</span>
                  <cx-color-picker
                      class="custom-title-color width-72"
                      :isThemeColor.sync="titleTextIsThemeColor"
                      :colorArr.sync="titleColor"
                  ></cx-color-picker>
                </div> -->
                <div class="verticallyCenter mb16">
                  <span class="fs14 mr16">背景颜色</span>
                  <cx-color-picker
                      class="custom-title-color flex1"
                      :isThemeColor.sync="titleBgColorIsThemeColor"
                      :colorArr.sync="titleBgColor"
                  ></cx-color-picker>
                </div>
                <div class="content-item mb16">
                  <cx-padding
                      :paddingTypeFlag.sync="titlePaddingTypeFlag"
                      :padding.sync="titlePadding"
                      :paddingTop.sync="titlePaddingTop"
                      :paddingRight.sync="titlePaddingRight"
                      :paddingBottom.sync="titlePaddingBottom"
                      :paddingLeft.sync="titlePaddingLeft"
                  />
                </div>
              </div>
            </div>
          </div>
        </el-collapse-item>
        <el-collapse-item
            @mousedown.native="collapseMouseDown(collapseActiveNames, $event, '4')"
            title="日历样式"
            name="4"
        >
          <div
              class="setting-item"
              v-if="collapseActiveNames.length !== 0 && collapseActiveNames.find(it => it === '4')"
          >
            <div class="content">
              <div class="content-item mb16">
                <div class="date-border-box">
                  <cx-background :background.sync="selectBackground" imgType="10" :hasAddBtn="false"/>
                </div>
              </div>
              <collapsibleItem >
                <div slot="heading">默认样式</div>
                <div slot="body">
                  <div class="content-item mb16">
                    <p class="font14 mb16">文字样式</p>
                    <text-setting-update
                        :fontColor.sync="selectFontColor"
                        :fontFamily.sync="selectFontFamily"
                        :fontSize.sync="selectFontSize"
                        :fontWeight.sync="selectFontWeight"
                    />
                  </div>
                  <div class="content-item mb16">
                    <p class="fs14 mb16">非本月日期颜色</p>
                    <cx-color-picker
                        class="custom-title-color"
                        :isThemeColor.sync="notCurrentTextIsThemeColor"
                        :colorArr.sync="notCurrentTextColor"
                    ></cx-color-picker>
                  </div>
                  <div class="content-item mb16">
                    <div class="border-radius-header mb16 fs14">上下边距</div>
                    <div class="setting-item-grid home">
                      <slider-and-input
                          :value.sync="datePaddingTopVal"
                          :sliderMax="sliderMax"
                          suffix="px"
                          class="mt16"
                          className="grid_home edge_2"
                          inputWidth="small"
                          inputHeight="small"
                          tips="上边距"
                      />
                      <slider-and-input
                          :value.sync="datePaddingBottomVal"
                          :sliderMax="sliderMax"
                          suffix="px"
                          class="mt16"
                          className="grid_home edge_4"
                          inputWidth="small"
                          inputHeight="small"
                          tips="下边距"
                      />
                    </div>
                  </div>
                </div>
              </collapsibleItem>
              <collapsibleItem >
                <div slot="heading">选中样式</div>
                <div slot="body">
                  <div class="content-item mb16">
                    <p class="font14 mb16">文字样式</p>
                    <text-setting-update
                        :fontColor.sync="activeFontColor"
                        :fontFamily.sync="activeFontFamily"
                        :fontSize.sync="activeFontSize"
                        :fontWeight.sync="activeFontWeight"
                    />
                  </div>
                  <div class="content-item mb16">
                    <border-radius
                        :borderTypeFlag.sync="activeBorderTypeFlag"
                        :borderRadius.sync="activeBorderRadius"
                        :borderTopLeftRadius.sync="activeBorderTopLeftRadius"
                        :borderTopRightRadius.sync="activeBorderTopRightRadius"
                        :borderBottomRightRadius.sync="activeBorderBottomRightRadius"
                        :borderBottomLeftRadius.sync="activeBorderBottomLeftRadius"
                    />
                  </div>
                  <div class="content-item mb16">
                    <div class="checkbox_colorPicker_container mb16">
                      <cx-check-box :value.sync="showActiveBorder">显示边框</cx-check-box>
                    </div>
                    <div class="verticallyCenter date-border-box" v-if="showActiveBorder">
                      <span class="fs14 mr16">颜色</span>
                      <cx-color-picker
                          class="custom-title-color flex1"
                          :isThemeColor.sync="activeBorderIsThemeColor"
                          :colorArr.sync="activeBorderColor"
                      ></cx-color-picker>
                    </div>
                  </div>
                  <div class="content-item mb16">
                    <div class="">
                      <p class="fs14 mb16">背景颜色</p>
                      <cx-color-picker
                          class="custom-title-color"
                          :isThemeColor.sync="activeBgColorIsThemeColor"
                          :colorArr.sync="activeBgColor"
                      ></cx-color-picker>
                    </div>
                  </div>
                </div>
              </collapsibleItem>
              <collapsibleItem >
                <div slot="heading">悬浮样式</div>
                <div slot="body">
                  <div class="content-item mb16">
                    <p class="font14 mb16">文字样式</p>
                    <text-setting-update
                        :fontColor.sync="hoverFontColor"
                        :fontFamily.sync="hoverFontFamily"
                        :fontSize.sync="hoverFontSize"
                        :fontWeight.sync="hoverFontWeight"
                    />
                  </div>
                  <div class="content-item mb16">
                    <border-radius
                        :borderTypeFlag.sync="hoverBorderTypeFlag"
                        :borderRadius.sync="hoverBorderRadius"
                        :borderTopLeftRadius.sync="hoverBorderTopLeftRadius"
                        :borderTopRightRadius.sync="hoverBorderTopRightRadius"
                        :borderBottomRightRadius.sync="hoverBorderBottomRightRadius"
                        :borderBottomLeftRadius.sync="hoverBorderBottomLeftRadius"
                    />
                  </div>
                  <div class="content-item mb16">
                    <div class="checkbox_colorPicker_container mb16">
                      <cx-check-box :value.sync="showHoverBorder">显示边框</cx-check-box>
                    </div>
                    <div class="verticallyCenter date-border-box" v-if="showHoverBorder">
                      <span class="fs14 mr16">颜色</span>
                      <cx-color-picker
                          class="custom-title-color flex1"
                          :isThemeColor.sync="hoverBorderIsThemeColor"
                          :colorArr.sync="hoverBorderColor"
                      ></cx-color-picker>
                    </div>
                  </div>
                  <div class="content-item mb16">
                    <p class="fs14 mb16">背景颜色</p>
                    <cx-color-picker
                        class="custom-title-color"
                        :isThemeColor.sync="hoverBgColorIsThemeColor"
                        :colorArr.sync="hoverBgColor"
                    ></cx-color-picker>
                  </div>
                </div>
              </collapsibleItem>
              <collapsibleItem>
                <div slot="heading">时间输入框样式</div>
                <div slot="body">
                  <div class="content-item mb16">
                    <p class="font14 mb16">文字样式</p>
                    <text-setting-update
                        :fontColor.sync="rangeInpFontColor"
                        :fontFamily.sync="rangeInpFontFamily"
                        :fontSize.sync="rangeInpFontSize"
                        :fontWeight.sync="rangeInpFontWeight"
                    />
                  </div>
                  <div class="content-item mb16">
                    <div class="date-border-box">
                      <cx-background :background.sync="rangeInpBackground" imgType="10" :hasAddBtn="false"/>
                    </div>
                  </div>
                </div>
              </collapsibleItem>
            </div>
          </div>
        </el-collapse-item>
        <el-collapse-item
            @mousedown.native="collapseMouseDown(collapseActiveNames, $event, '7')"
            title="分割线样式"
            name="7"
        >
          <div
              class="setting-item clearFloat mb16"
              v-if="collapseActiveNames.length !== 0 && collapseActiveNames.find(it => it === '7')"
          >
            <div class="verticallyCenter mb16">
              <span class="fs14 mr16">颜色</span>
              <cx-color-picker
                  class="custom-title-color flex1"
                  :isThemeColor.sync="lineColorIsThemeColor"
                  :colorArr.sync="lineColor"
              ></cx-color-picker>
            </div>
          </div>
        </el-collapse-item>
        <el-collapse-item
            @mousedown.native="collapseMouseDown(collapseActiveNames, $event, '8')"
            title="按钮样式"
            name="8"
        >
          <div
              class="setting-item clearFloat mb16"
              v-if="collapseActiveNames.length !== 0 && collapseActiveNames.find(it => it === '8')"
          >
            <div class="content">
              <div>
                <collapsibleItem>
                  <div slot="heading">确认按钮样式</div>
                  <div slot="body">
                    <div class="content-item mb16">
                      <p class="font14 mb16">文字样式</p>
                      <text-setting-update
                          :fontColor.sync="primaryBtnFontColor"
                          :fontFamily.sync="primaryBtnFontFamily"
                          :fontSize.sync="primaryBtnFontSize"
                          :fontWeight.sync="primaryBtnFontWeight"
                      />
                    </div>
                    <div class="content-item mb16">
                      <p class="fs14 mb16">背景颜色</p>
                      <cx-color-picker
                          class="custom-title-color"
                          :isThemeColor.sync="primaryBtnBgColorIsThemeColor"
                          :colorArr.sync="primaryBtnBgColor"
                      ></cx-color-picker>
                    </div>
                    <div class="content-item mb16">
                      <p class="fs14 mb16">边框</p>
                      <cx-border
                          :borderWidth.sync="primaryBtnBorderWidth"
                          :borderStyle.sync="primaryBtnBorderStyle"
                          :borderColor.sync="primaryBtnBorderColor"
                          :borderIsThemeColor.sync="primaryBtnBorderIsThemeColor"
                      />
                    </div>
                  </div>
                </collapsibleItem>
              </div>
              <div>
                <collapsibleItem>
                  <div slot="heading">取消按钮样式</div>
                  <div slot="body">
                    <div class="content-item mb16">
                      <p class="font14 mb16">文字样式</p>
                      <text-setting-update
                          :fontColor.sync="cancleBtnFontColor"
                          :fontFamily.sync="cancleBtnFontFamily"
                          :fontSize.sync="cancleBtnFontSize"
                          :fontWeight.sync="cancleBtnFontWeight"
                      />
                    </div>
                    <div class="content-item mb16">
                      <p class="fs14 mb16">背景颜色</p>
                      <cx-color-picker
                          class="custom-title-color"
                          :isThemeColor.sync="cancleBtnBgColorIsThemeColor"
                          :colorArr.sync="cancleBtnBgColor"
                      ></cx-color-picker>
                    </div>
                    <div class="content-item mb16">
                      <p class="fs14 mb16">边框</p>
                      <cx-border
                          :borderWidth.sync="cancleBtnBorderWidth"
                          :borderStyle.sync="cancleBtnBorderStyle"
                          :borderColor.sync="cancleBtnBorderColor"
                          :borderIsThemeColor.sync="cancleBtnBorderIsThemeColor"
                      />
                    </div>
                  </div>
                </collapsibleItem>
              </div>
            </div>
          </div>
        </el-collapse-item>
      </el-collapse>
    </div>
  </div>
</template>

<script>
import controlWidthAndSizeAndZindex from "publicSetting/controlWidthAndSizeAndZindex.vue"
import { withMethodsHistoryCombine } from "utils/revork"
export default withMethodsHistoryCombine({
  name: "date-options-data",
  components: {
    controlWidthAndSizeAndZindex,
    bigScreenAnimateSet: () => import("components/stageComponents/toolbar/bigScreen-animate-set.vue")
  },
  props: {options: Object},
  data() {
    return {
      activeNames: ["1", "2", "3", "4"],
      this1: this,
      collapseActiveNames: ["1", "2", "3", "4"],
      activeStatus: "status0",
      activeStart: "start0",
      sliderMax: 100,
      dateTypes: [
        {
          dataPickerType: 1,
          list: [
            {
              label: 'year',
              value: 'year'
            }, {
              label: 'month',
              value: 'month'
            }, {
              label: 'date',
              value: 'date'
            },
            {
              label: 'week',
              value: 'week'
            },
            {
              label: 'datetime',
              value: 'datetime'
            },
          ]
        },
        {
          dataPickerType: 2,
          list: [
            {
              label: 'dates',
              value: 'dates'
            }, {
              label: 'years',
              value: 'years'
            }
          ]
        },
        {
          dataPickerType: 3,
          list: [
            {
              label: 'datetimerange',
              value: 'datetimerange'
            }, {
              label: 'daterange',
              value: 'daterange'
            }, {
              label: 'monthrange',
              value: 'monthrange'
            }
          ]
        }
      ],
      dateFormatOptions: [
        {
          type: 'year',
          formatOptions: [{
            label: 'yyyy年',
            value: 'yyyy年'
          }]
        }, {
          type: 'month',
          formatOptions: [{
            label: 'yyyy年MM月',
            value: 'yyyy年MM月'
          }, {
            label: 'yyyy-MM',
            value: 'yyyy-MM'
          }, {
            label: 'yyyy/MM',
            value: 'yyyy/MM'
          }]
        }, {
          type: 'date',
          formatOptions: [{
            label: 'yyyy年MM月dd日',
            value: 'yyyy年MM月dd日'
          }, {
            label: 'yyyy-MM-dd',
            value: 'yyyy-MM-dd'
          }, {
            label: 'yyyy/MM/dd',
            value: 'yyyy/MM/dd'
          }]
        }, {
          type: 'week',
          formatOptions: [{
            label: 'yyyy年第W周',
            value: 'yyyy年第W周'
          }]
        }, {
          type: 'datetime',
          formatOptions: [{
            label: 'yyyy年MM月dd日 HH:mm:ss',
            value: 'yyyy年MM月dd日 HH:mm:ss'
          }, {
            label: 'yyyy-MM-dd HH:mm:ss',
            value: 'yyyy-MM-dd HH:mm:ss'
          }, {
            label: 'yyyy/MM/dd HH:mm:ss',
            value: 'yyyy/MM/dd HH:mm:ss'
          }, {
            label: 'yyyy/MM/dd hh:mm:ss',
            value: 'yyyy/MM/dd hh:mm:ss'
          }]
        },
        {
          type: 'datetimerange',
          formatOptions: [{
            label: 'yyyy年MM月dd日 HH:mm:ss',
            value: 'yyyy年MM月dd日 HH:mm:ss'
          }, {
            label: 'yyyy-MM-dd HH:mm:ss',
            value: 'yyyy-MM-dd HH:mm:ss'
          }, {
            label: 'yyyy/MM/dd HH:mm:ss',
            value: 'yyyy/MM/dd HH:mm:ss'
          }, {
            label: 'yyyy/MM/dd hh:mm:ss',
            value: 'yyyy/MM/dd hh:mm:ss'
          }]
        }, {
          type: 'daterange',
          formatOptions: [{
            label: 'yyyy年MM月dd日',
            value: 'yyyy年MM月dd日'
          }, {
            label: 'yyyy-MM-dd',
            value: 'yyyy-MM-dd'
          }, {
            label: 'yyyy/MM/dd',
            value: 'yyyy/MM/dd'
          }]
        }, {
          type: 'monthrange',
          formatOptions: [{
            label: 'yyyy年MM月',
            value: 'yyyy年MM月'
          }, {
            label: 'yyyy-MM',
            value: 'yyyy-MM'
          }, {
            label: 'yyyy/MM',
            value: 'yyyy/MM'
          }]
        },
        {
          type: 'dates',
          formatOptions: [{
            label: 'yyyy年MM月dd日',
            value: 'yyyy年MM月dd日'
          }, {
            label: 'yyyy-MM-dd',
            value: 'yyyy-MM-dd'
          }, {
            label: 'yyyy/MM/dd',
            value: 'yyyy/MM/dd'
          }]
        }, {
          type: 'months',
          formatOptions: [{
            label: 'yyyy年MM月',
            value: 'yyyy年MM月'
          }, {
            label: 'yyyy-MM',
            value: 'yyyy-MM'
          }, {
            label: 'yyyy/MM',
            value: 'yyyy/MM'
          }]
        }, {
          type: 'years',
          formatOptions: [{
            label: 'yyyy年',
            value: 'yyyy年'
          }]
        }
      ],
      shortcutsOptions: [
        {
          label: '今天',
          value: '今天'
        },
        {
          label: '本月',
          value: '本月'
        },
        {
          label: '本年',
          value: '本年'
        }
      ]
    }
  },
  comments: {},
  created() {
  },

  computed: {
    ids() {
      return this.$store.state.states.activeID
    },
    width: {
      get() {
        return this.options.width
      },
      set(newVal) {
        this.$changeOptionsEV(parseInt(newVal), "width", false)
      }
    },
    height: {
      get() {
        return this.options.height
      },
      set(newVal) {
        this.$changeOptionsEV(parseInt(newVal), "height", false)
      }
    },
    left: {
      get() {
        return this.options.left
      },
      set(newVal) {
        this.$changeOptionsEV(parseInt(newVal), "left", false)
      }
    },
    top: {
      get() {
        return this.options.top
      },
      set(newVal) {
        this.$changeOptionsEV(parseInt(newVal), "top", false)
      }
    },
    rotate: {
      get() {
        return parseInt(this.options.rotate)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal + "deg", "rotate", false)
      }
    },
    dateType: {
      get() {
        return this.options.dateType
      },
      set(newVal) {
        //将formater 换成改选项下的第一个
        let tempData = this.dateFormatOptions.find(item => item.type === newVal)
        tempData = tempData.formatOptions
        let index = tempData.findIndex(item => item.value === this.dateFormat)
        if (index === -1) {
          this.dateFormat = tempData[0].value
        }
        this.$changeOptionsEV(newVal, "dateType", false)
      }
    },
    dateTypesOption() {
      let tempData = this.dateTypes.find(item => item.dataPickerType === this.options.dataPickerType)
      return tempData ? tempData.list : []
    },
    dateFormat: {
      get() {
        return this.options.dateFormat
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "dateFormat", false)
      }
    },
    formatOptions() {
      let tempData = this.dateFormatOptions.find(item => item.type === this.dateType)
      return tempData ? tempData.formatOptions : []
    },
    fontSize: {
      get() {
        return this.options.fontSize || 12
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "fontSize", false)
      }
    },
    fontFamily: {
      get() {
        return this.options.fontFamily
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "fontFamily", false)
      }
    },
    fontWeight: {
      get() {
        return this.options.fontWeight
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "fontWeight", false)
      }
    },
    fontColor: {
      get() {
        return this.options.fontColor
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "fontColor", false)
      }
    },
    borderTopLeftRadius: {
      get() {
        return Number(this.options.borderTopLeftRadius) || 0
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "borderTopLeftRadius", false)
      }
    },
    borderTopRightRadius: {
      get() {
        return Number(this.options.borderTopRightRadius) || 0
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "borderTopRightRadius", false)
      }
    },
    borderBottomRightRadius: {
      get() {
        return Number(this.options.borderBottomRightRadius) || 0
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "borderBottomRightRadius", false)
      }
    },
    borderBottomLeftRadius: {
      get() {
        return Number(this.options.borderBottomLeftRadius) || 0
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "borderBottomLeftRadius", false)
      }
    },
    borderRadius: {
      get() {
        return Number(this.options.borderBottomLeftRadius) || 0
      },
      set(newVal) {
        this.$changeOptionsEV(
          [newVal, newVal, newVal, newVal],
          ["borderTopLeftRadius", "borderTopRightRadius", "borderBottomRightRadius", "borderBottomLeftRadius"],
          false
        )
      }
    },
    borderStyle: {
      get() {
        return this.options.borderStyle
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "borderStyle", false)
      }
    },
    borderColor: {
      get() {
        return this.options.borderColor
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "borderColor", false)
      }
    },
    borderTypeFlag: {
      get() {
        let defaultType = 1
        if (!this.options.hasOwnProperty("borderTypeFlag")) {
          if (
              ((this.borderTopLeftRadius === this.borderTopRightRadius) === this.borderBottomLeftRadius) ===
              this.borderBottomRightRadius
          ) {
            defaultType = 2
          }
        }
        // return this.checkAndSetPrimaryVal(this.options, "borderTypeFlag", "borderTypeFlag", defaultType)
        // 上面方法貌似是执行需要一定的时间，造成最开始还未写入值，进行点击 会出现问题
        return this.options.borderTypeFlag || defaultType
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "borderTypeFlag", false)
      }
    },
    borderWidth: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "borderWidth", "borderWidth", 0)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "borderWidth", false)
      }
    },
    borderIsThemeColor: {
      get() {
        return this.options.borderIsThemeColor
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "borderIsThemeColor", false)
      }
    },
    boxShadowColor: {
      get() {
        return this.options.boxShadowColor
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "boxShadowColor", false)
      }
    },
    boxShadowH: {
      get() {
        return this.options.boxShadowH
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "boxShadowH", false)
      }
    },
    boxShadowV: {
      get() {
        return this.options.boxShadowV
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "boxShadowV", false)
      }
    },
    boxShadowBlur: {
      get() {
        return this.options.boxShadowBlur
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "boxShadowBlur", false)
      }
    },
    boxShadowSpread: {
      get() {
        return this.options.boxShadowSpread
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "boxShadowSpread", false)
      }
    },
    background: {
      get() {
        return this.options.background
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "background", false)
      }
    },
    // shortcuts: {
    //   get() {
    //     return this.options.shortcuts
    //   },
    //   set(newVal) {
    //     this.$changeOptionsEV(newVal, "shortcuts", false)
    //   }
    // },
    // showShortcuts: {
    //   get() {
    //     return this.options.showShortcuts
    //   },
    //   set(newVal) {
    //     this.$changeOptionsEV(newVal, "showShortcuts", false)
    //   }
    // },
    selectBackground: {
      get() {
        return this.options.selectBackground
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "selectBackground", false)
      }
    },
    selectFontFamily: {
      get() {
        return this.options.selectFontFamily
      },
      set(val) {
        this.$changeOptionsEV(val, "selectFontFamily", false)
      }
    },
    selectFontSize: {
      get() {
        return this.options.selectFontSize
      },
      set(val) {
        this.$changeOptionsEV(val, "selectFontSize", false)
      }
    },
    selectFontWeight: {
      get() {
        return this.options.selectFontWeight
      },
      set(val) {
        this.$changeOptionsEV(val, "selectFontWeight", false)
      }
    },
    selectFontColor: {
      get() {
        return this.options.selectFontColor
      },
      set(val) {
        this.$changeOptionsEV(val, "selectFontColor", false)
      }
    },
    selectBorderColor: {
      get() {
        return this.options.selectBorderColor
      },
      set(val) {
        this.$changeOptionsEV(val, "selectBorderColor", false)
      }
    },
    selectBorderWidth: {
      get() {
        return this.options.selectBorderWidth
      },
      set(val) {
        this.$changeOptionsEV(val, "selectBorderWidth", false)
      }
    },
    selectBorderStyle: {
      get() {
        return this.options.selectBorderStyle
      },
      set(val) {
        this.$changeOptionsEV(val, "selectBorderStyle", false)
      }
    },
    selectBorderIsThemeColor: {
      get() {
        return this.options.selectBorderIsThemeColor
      },
      set(val) {
        this.$changeOptionsEV(val, "selectBorderIsThemeColor", false)
      }
    },
    notCurrentTextIsThemeColor: {
      get() {
        return this.options.notCurrentTextIsThemeColor
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "notCurrentTextIsThemeColor", false)
      }
    },
    notCurrentTextColor: {
      get() {
        return this.options.notCurrentTextColor
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "notCurrentTextColor", false)
      }
    },
    activeFontFamily: {
      get() {
        return this.options.activeFontFamily
      },
      set(val) {
        this.$changeOptionsEV(val, "activeFontFamily", false)
      }
    },
    activeFontSize: {
      get() {
        return this.options.activeFontSize
      },
      set(val) {
        this.$changeOptionsEV(val, "activeFontSize", false)
      }
    },
    activeFontWeight: {
      get() {
        return this.options.activeFontWeight
      },
      set(val) {
        this.$changeOptionsEV(val, "activeFontWeight", false)
      }
    },
    activeFontColor: {
      get() {
        return this.options.activeFontColor
      },
      set(val) {
        this.$changeOptionsEV(val, "activeFontColor", false)
      }
    },
    activeBorderTypeFlag: {
      get() {
        return this.options.activeBorderTypeFlag || 2
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "activeBorderTypeFlag", false)
      }
    },
    activeBorderRadius: {
      get() {
        return this.options.activeBorderRadius || 0
      },
      set(newVal) {
        if (this.activeBorderTypeFlag === 2) {
          this.activeBorderTopLeftRadius = newVal
          this.activeBorderTopRightRadius = newVal
          this.activeBorderBottomRightRadius = newVal
          this.activeBorderBottomLeftRadius = newVal
        }
        this.$changeOptionsEV(newVal, "activeBorderRadius", false)
      }
    },
    activeBorderTopLeftRadius: {
      get() {
        return this.options.activeBorderTopLeftRadius || 0
      },
      set(newVal) {
        if (this.activeBorderTypeFlag === 2) {
          this.$changeOptionsEV(parseInt(newVal), "activeBorderTopRightRadius", false)
          this.$changeOptionsEV(parseInt(newVal), "activeBorderBottomRightRadius", false)
          this.$changeOptionsEV(parseInt(newVal), "activeBorderBottomLeftRadius", false)
        }
        this.$changeOptionsEV(newVal, "activeBorderTopLeftRadius", false)
      }
    },
    activeBorderTopRightRadius: {
      get() {
        return this.options.activeBorderTopRightRadius || 0
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "activeBorderTopRightRadius", false)
      }
    },
    activeBorderBottomRightRadius: {
      get() {
        return this.options.activeBorderBottomRightRadius || 0
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "activeBorderBottomRightRadius", false)
      }
    },
    activeBorderBottomLeftRadius: {
      get() {
        return this.options.activeBorderBottomLeftRadius || 0
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "activeBorderBottomLeftRadius", false)
      }
    },
    activeBgColor:{
      get() {
        return this.options.activeBgColor
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "activeBgColor", false)
      }
    },
    activeBgColorIsThemeColor:{
      get() {
        return this.options.activeBgColorIsThemeColor
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "activeBgColorIsThemeColor", false)
      }
    },
    activeBorderColor:{
      get() {
        return this.options.activeBorderColor
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "activeBorderColor", false)
      }
    },
    showActiveBorder:{
      get() {
        return this.options.showActiveBorder
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "showActiveBorder", false)
      }
    },
    activeBorderIsThemeColor:{
      get() {
        return this.options.activeBorderIsThemeColor
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "activeBorderIsThemeColor", false)
      }
    },

    hoverFontFamily: {
      get() {
        return this.options.hoverFontFamily
      },
      set(val) {
        this.$changeOptionsEV(val, "hoverFontFamily", false)
      }
    },
    hoverFontSize: {
      get() {
        return this.options.hoverFontSize
      },
      set(val) {
        this.$changeOptionsEV(val, "hoverFontSize", false)
      }
    },
    hoverFontWeight: {
      get() {
        return this.options.hoverFontWeight
      },
      set(val) {
        this.$changeOptionsEV(val, "hoverFontWeight", false)
      }
    },
    hoverFontColor: {
      get() {
        return this.options.hoverFontColor
      },
      set(val) {
        this.$changeOptionsEV(val, "hoverFontColor", false)
      }
    },
    hoverBorderTypeFlag: {
      get() {
        return this.options.hoverBorderTypeFlag || 2
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "hoverBorderTypeFlag", false)
      }
    },
    hoverBorderRadius: {
      get() {
        return this.checkAndSetPrimaryVal(
            this.options,
            "hoverBorderRadius",
            "hoverBorderRadius",
            this.hoverBorderTopLeftRadius
        )
      },
      set(newVal) {
        if (this.hoverBorderTypeFlag === 2) {
          this.hoverBorderTopLeftRadius = newVal
          this.hoverBorderTopRightRadius = newVal
          this.hoverBorderBottomRightRadius = newVal
          this.hoverBorderBottomLeftRadius = newVal
        }
        this.$changeOptionsEV(newVal, "hoverBorderRadius", false)
      }
    },
    hoverBorderTopLeftRadius: {
      get() {
        return this.options.hoverBorderTopLeftRadius || 0
      },
      set(newVal) {
        if (this.hoverBorderTypeFlag === 2) {
          this.$changeOptionsEV(parseInt(newVal), "hoverBorderTopRightRadius", false)
          this.$changeOptionsEV(parseInt(newVal), "hoverBorderBottomRightRadius", false)
          this.$changeOptionsEV(parseInt(newVal), "hoverBorderBottomLeftRadius", false)
        }
        this.$changeOptionsEV(newVal, "hoverBorderTopLeftRadius", false)
      }
    },
    hoverBorderTopRightRadius: {
      get() {
        return this.options.hoverBorderTopRightRadius || 0
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "hoverBorderTopRightRadius", false)
      }
    },
    hoverBorderBottomRightRadius: {
      get() {
        return this.options.hoverBorderBottomRightRadius || 0
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "hoverBorderBottomRightRadius", false)
      }
    },
    hoverBorderBottomLeftRadius: {
      get() {
        return this.options.hoverBorderBottomLeftRadius || 0
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "hoverBorderBottomLeftRadius", false)
      }
    },
    hoverBgColor:{
      get() {
        return this.options.hoverBgColor
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "hoverBgColor", false)
      }
    },
    hoverBgColorIsThemeColor:{
      get() {
        return this.options.hoverBgColorIsThemeColor
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "hoverBgColorIsThemeColor", false)
      }
    },
    hoverBorderColor:{
      get() {
        return this.options.hoverBorderColor
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "hoverBorderColor", false)
      }
    },
    showHoverBorder:{
      get() {
        return this.options.showHoverBorder
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "showHoverBorder", false)
      }
    },
    hoverBorderIsThemeColor:{
      get() {
        return this.options.hoverBorderIsThemeColor
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "hoverBorderIsThemeColor", false)
      }
    },

    titleFontFamily: {
      get() {
        return this.options.titleFontFamily
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "titleFontFamily", false)
      }
    },
    titleFontSize: {
      get() {
        return this.options.titleFontSize
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "titleFontSize", false)
      }
    },
    titleFontWeight: {
      get() {
        return this.options.titleFontWeight
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "titleFontWeight", false)
      }
    },
    titleFontStyle: {
      get() {
        return this.options.titleFontStyle
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "titleFontStyle", false)
      }
    },
    titleTextDecoration: {
      get() {
        return this.options.titleTextDecoration || "none"
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "titleTextDecoration", false)
      }
    },
    titleLineHeight: {
      get() {
        return this.options.titleLineHeight || 50
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "titleLineHeight", false)
      }
    },
    titleLineHeightType: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "titleLineHeightType", "titleLineHeightType", "px")
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "titleLineHeightType", false)
      }
    },
    titleLetterSpacing: {
      get() {
        return this.options.titleLetterSpacing || 0
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "titleLetterSpacing", false)
      }
    },
    titleWritingMode: {
      get() {
        return this.options.titleWritingMode || "horizontal-tb"
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "titleWritingMode", false)
      }
    },
    titleTextAlign: {
      get() {
        return this.options.titleTextAlign || "center"
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "titleTextAlign", false)
      }
    },
    titleActiveArrangement() {
      return this.options.titleTextAlign || "left"
    },
    titleActiveArrangementOrder: {
      get() {
        return {
          _class: "icon-portal-text-down1",
          isActive: this.options.titleWritingMode === "vertical-lr" ? true : false
        }
      },
      set(newVal) {
        let val = newVal ? "vertical-lr" : "horizontal-tb"
        this.$changeOptionsEV(val, "titleWritingMode", false)
      }
    },
    titleTextIsThemeColor: {
      get() {
        return this.options.titleTextIsThemeColor || false
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "titleTextIsThemeColor", false)
      }
    },
    titleColor: {
      get() {
        return this.options.titleColor
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "titleColor", false)
      }
    },
    titleBgColorIsThemeColor: {
      get() {
        return this.options.titleBgColorIsThemeColor || false
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "titleBgColorIsThemeColor", false)
      }
    },
    titleBgColor: {
      get() {
        return this.options.titleBgColor
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "titleBgColor", false)
      }
    },
    // 标题边距
    titlePaddingTypeFlag: {
      get() {
        let defaultType = 2
        if (((this.titlePaddingTop === this.titlePaddingRight) === this.titlePaddingLeft) === this.titlePaddingBottom) {
          defaultType = 1
        }
        return this.options.titlePaddingTypeFlag || defaultType
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "titlePaddingTypeFlag", false)
      }
    },
    titlePadding: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "titlePadding", "titlePadding", 0)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "titlePadding", false)
      }
    },
    titlePaddingTop: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "titlePaddingTop", "titlePaddingTop", 0)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "titlePaddingTop", false)
      }
    },
    titlePaddingRight: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "titlePaddingRight", "titlePaddingRight", 0)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "titlePaddingRight", false)
      }
    },
    titlePaddingLeft: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "titlePaddingLeft", "titlePaddingLeft", 0)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "titlePaddingLeft", false)
      }
    },
    titlePaddingBottom: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "titlePaddingBottom", "titlePaddingBottom", 0)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "titlePaddingBottom", false)
      }
    },
    lineColor: {
      get() {
        return this.options.lineColor
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "lineColor", false)
      }
    },
    lineColorIsThemeColor: {
      get() {
        return this.options.lineColorIsThemeColor
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "lineColorIsThemeColor", false)
      }
    },
    datePaddingTopVal:{
      get() {
        return this.options.datePaddingTopVal
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "datePaddingTopVal", false)
      }
    },
    datePaddingBottomVal:{
      get() {
        return this.options.datePaddingBottomVal
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "datePaddingBottomVal", false)
      }
    },
    primaryBtnFontSize:{
      get() {
        return this.options.primaryBtnFontSize
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "primaryBtnFontSize", false)
      }
    },
    primaryBtnFontFamily:{
      get() {
        return this.options.primaryBtnFontFamily
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "primaryBtnFontFamily", false)
      }
    },
    primaryBtnFontWeight:{
      get() {
        return this.options.primaryBtnFontWeight
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "primaryBtnFontWeight", false)
      }
    },
    primaryBtnFontColor:{
      get() {
        return this.options.primaryBtnFontColor
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "primaryBtnFontColor", false)
      }
    },
    primaryBtnBgColor:{
      get() {
        return this.options.primaryBtnBgColor
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "primaryBtnBgColor", false)
      }
    },
    primaryBtnBgColorIsThemeColor:{
      get() {
        return this.options.primaryBtnBgColorIsThemeColor
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "primaryBtnBgColorIsThemeColor", false)
      }
    },
    primaryBtnBorderColor:{
      get() {
        return this.options.primaryBtnBorderColor
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "primaryBtnBorderColor", false)
      }
    },
    primaryBtnBorderWidth:{
      get() {
        return this.options.primaryBtnBorderWidth
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "primaryBtnBorderWidth", false)
      }
    },
    primaryBtnBorderStyle:{
      get() {
        return this.options.primaryBtnBorderStyle
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "primaryBtnBorderStyle", false)
      }
    },
    primaryBtnBorderIsThemeColor:{
      get() {
        return this.options.primaryBtnBorderIsThemeColor
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "primaryBtnBorderIsThemeColor", false)
      }
    },
    cancleBtnFontSize:{
      get() {
        return this.options.cancleBtnFontSize
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "cancleBtnFontSize", false)
      }
    },
    cancleBtnFontFamily:{
      get() {
        return this.options.cancleBtnFontFamily
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "cancleBtnFontFamily", false)
      }
    },
    cancleBtnFontWeight:{
      get() {
        return this.options.cancleBtnFontWeight
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "cancleBtnFontWeight", false)
      }
    },
    cancleBtnFontColor:{
      get() {
        return this.options.cancleBtnFontColor
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "cancleBtnFontColor", false)
      }
    },
    cancleBtnBgColor:{
      get() {
        return this.options.cancleBtnBgColor
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "cancleBtnBgColor", false)
      }
    },
    cancleBtnBgColorIsThemeColor:{
      get() {
        return this.options.cancleBtnBgColorIsThemeColor
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "cancleBtnBgColorIsThemeColor", false)
      }
    },
    cancleBtnBorderColor:{
      get() {
        return this.options.cancleBtnBorderColor
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "cancleBtnBorderColor", false)
      }
    },
    cancleBtnBorderWidth:{
      get() {
        return this.options.cancleBtnBorderWidth
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "cancleBtnBorderWidth", false)
      }
    },
    cancleBtnBorderStyle:{
      get() {
        return this.options.cancleBtnBorderStyle
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "cancleBtnBorderStyle", false)
      }
    },
    cancleBtnBorderIsThemeColor:{
      get() {
        return this.options.cancleBtnBorderIsThemeColor
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "cancleBtnBorderIsThemeColor", false)
      }
    },
    rangeInpFontFamily: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "rangeInpFontFamily", "rangeInpFontFamily", 'sans-serif')
      },
      set(val) {
        this.$changeOptionsEV(val, "rangeInpFontFamily", false)
      }
    },
    rangeInpFontSize: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "rangeInpFontSize", "rangeInpFontSize", 13)
      },
      set(val) {
        this.$changeOptionsEV(val, "rangeInpFontSize", false)
      }
    },
    rangeInpFontWeight: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "rangeInpFontWeight", "rangeInpFontWeight", 400)
      },
      set(val) {
        this.$changeOptionsEV(val, "rangeInpFontWeight", false)
      }
    },
    rangeInpFontColor: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "rangeInpFontColor", "rangeInpFontColor", 'rgba(255, 255, 255, 0.2)')
      },
      set(val) {
        this.$changeOptionsEV(val, "rangeInpFontColor", false)
      }
    },
    rangeInpBackground:{
      get() {
        return this.checkAndSetPrimaryVal(this.options, "rangeInpBackground", "rangeInpBackground", [{
          type: 'color',
          isThemeColor : false,
          color: '#35383f',
          label: "颜色"
        }])
      },
      set(val) {
        this.$changeOptionsEV(val, "rangeInpBackground", false)
      }
    },
    defaultToday: {
      get() {
        return this.options.defaultToday || false
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "defaultToday", false)
      }
    },
    todayRange: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "todayRange", "todayRange", 1)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "todayRange", false)
      }
    },
    todayRangeTime: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "todayRangeTime", "todayRangeTime", 1)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "todayRangeTime", false)
      }
    },
    dateSelectRange: {
      get() {
        return this.options.dateSelectRange
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "dateSelectRange", false)
      }
    },
    selectRangeText: {
      get() {
        return this.options.selectRangeText || "before"
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "selectRangeText", false)
      }
    },
    selectRangeDate: {
      get() {
        return this.options.selectRangeDate || "today"
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "selectRangeDate", false)
      }
    },
    selectDate: {
      get() {
        return this.options.selectDate
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "selectDate", false)
      }
    },
  },
  methods: {
    // 抽屉展开收起方法
    collapsibleItemClickHandle($event, index) {
      this.collapse[$event.type].isActive = $event.isActiveCopy
      const _index = this.collapseDataActiveNames.findIndex(it => it === index)
      _index === -1 ? this.collapseDataActiveNames.push(index + "") : ""
    },
    addBoxshadow() {
      if (!Array.isArray(this.boxShadowH)) {
        this.boxShadowH = [this.boxShadowH]
        this.boxShadowV = [this.boxShadowV]
        this.boxShadowBlur = [this.boxShadowBlur]
        this.boxShadowSpread = [this.boxShadowSpread]
        this.boxShadowColor = [this.boxShadowColor]
      }
      let boxShadowH = JSON.parse(JSON.stringify(this.boxShadowH))
      let boxShadowV = JSON.parse(JSON.stringify(this.boxShadowV))
      let boxShadowBlur = JSON.parse(JSON.stringify(this.boxShadowBlur))
      let boxShadowSpread = JSON.parse(JSON.stringify(this.boxShadowSpread))
      let boxShadowColor = JSON.parse(JSON.stringify(this.boxShadowColor))
      boxShadowH.push(0)
      boxShadowV.push(4)
      boxShadowBlur.push(4)
      boxShadowSpread.push(0)
      boxShadowColor.push("rgba(0,0,0,0.25)")
      this.boxShadowH = boxShadowH
      this.boxShadowV = boxShadowV
      this.boxShadowBlur = boxShadowBlur
      this.boxShadowSpread = boxShadowSpread
      this.boxShadowColor = boxShadowColor
    }
  }
})
</script>

<style scoped lang="scss">
//p {
  //margin-bottom: 0;
//}

.w172 {
  width: 172px;
}

.w180 {
  width: 180px;
}

::v-deep.custom-date-color .el-color-picker,
::v-deep.custom-date-color .el-color-picker__trigger {
  width: 100%;
}

::v-deep .color-picker-container.custom-text-bg {
  width: calc(100% - 80px);
  display: inline-block;
  vertical-align: middle;
}

::v-deep .color-picker-container.custom-text-bg.custom-text-bg1 {
  width: 100%;
}

.paddingl0 {
  padding-left: 0;
}

::v-deep.el-select:hover .el-input__inner {
  border-color: rgba(23, 112, 255, 1);
}

.weather-options-setting-dialog ::v-deep.font-arrangement-btn {
  border: none;
  padding: 2px;
}
.borderRadius4{
  border-radius: 4px;
}
.padding16{
  padding: 16px;
}
.percent65_ {
  width: calc(100% - 65px);
}
.mapping_content {
  padding: 8px;
  color: rgba(0, 0, 0, 0.8);
  border-radius: 4px;
  border: 1px solid rgba(233, 233, 233, 1);
  background-color: rgba(247, 248, 250, 1);
}
.bigScreen .mapping_content {
  color: rgba(255, 255, 255, 0.8);
  border-color: var(--inputIconHoverBgColor);
  background-color: rgba(40, 42, 46, 1);
}
.mapping_content ::v-deep .el-input .el-input__inner {
  padding-left: 8px;
}

::v-deep .date-picker-box.el-input {
  width: 208px;
  .el-input__inner {
    padding-left: 30px;
  }
  .el-input__icon {
    line-height: 32px;
  }
}
::v-deep .el-date-editor .el-input__prefix {
  display: flex;
  align-items: center;
}
</style>
<style lang="scss">
.select-range-date {
  background: var(--leftMenuBgColor);
  border-color: var(--inputIconHoverBgColor);
  .el-input__inner {
    color: var(--textColor);
    &::placeholder {
      color: var(--thirdTextColor);
    }
  }
  .el-date-picker__time-header {
    border-color: var(--inputIconHoverBgColor);
  }
  .el-date-picker__header-label {
    color: var(--textColor);
  }
  .el-date-table th {
    border-bottom: none;
  }
  .el-date-table td span {
    color: var(--thirdTextColor);
  }
  .el-date-table .available span {
    color: var(--textColor);
  }
  .el-date-table td.current:not(.disabled) span {
    background-color: var(--themeColor);
  }
  .el-picker-panel__icon-btn {
    color: var(--thirdTextColor);
  }
  .el-date-picker__header--bordered {
    border-bottom: none;
  }
  .el-picker-panel__footer {
    background: var(--leftMenuBgColor);
    border-color: var(--inputIconHoverBgColor);
    .el-button.el-button--default {
      background-color: var(--themeColor);
      color: #fff;
    }
  }
}

</style>
